import * as types from '../constants/ActionTypes';
import { combineReducers } from 'redux';
import { connect } from 'react-redux';

const allStates = (state = false, action) => {
  console.log('reducer fired: all states')
  switch (action.type) {
    case types.GET_ALL_STATES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

const selectedState = (state = false, action) => {
  console.log('reducer fired: selected state')
  switch (action.type) {
    case types.SET_SELECTED_STATE:
      return action.state;
    default:
      return state;
  }
}

const states = combineReducers({
  allStates,
  selectedState
});

export default states;










// WEBPACK FOOTER //
// ./src/store/reducers/states.js